/* eslint-disable @typescript-eslint/no-explicit-any */

import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild
} from '@angular/core';
import { NgbDropdown, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { IconButtonDirective } from '../ui/icon-button.directive';
import { ActionMenuItemsComponent } from './action-menu-items.component';

export type ActionMenuOption = {
  label: string;
  disabled?: boolean | Observable<boolean>;
  danger?: boolean;
  divider?: boolean;
  callback?: (...args: any[]) => void;
};

@Component({
  selector: 'man-action-menu',
  templateUrl: './action-menu.component.html',
  styleUrls: ['./action-menu.component.scss'],
  standalone: true,
  imports: [
    ActionMenuItemsComponent,
    CommonModule,
    IconButtonDirective,
    NgbDropdownModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionMenuComponent {
  @Input() public options: ActionMenuOption[] = [];
  @Input() public data: any;
  @Input() public selectedCount = 0;
  @Input() public buttonIcon = 'fa-regular fa-ellipsis-vertical';
  @Input() public buttonVariant: 'muted' | 'outlined' | 'ghost' = 'ghost';
  @Input() public testId = 'action-menu';
  @Input() public isDisabled = false;

  @ViewChild('dropdown', { read: NgbDropdown }) public dropdown: NgbDropdown;

  private isMouseOver = false;

  public onOptionClick(option: ActionMenuOption): void {
    option.callback && option.callback(this.data);
  }

  public onMouseEnter(): void {
    this.isMouseOver = true;
  }

  public onMouseLeave(): void {
    this.isMouseOver = false;

    setTimeout(() => {
      if (this.isMouseOver) return;
      this.dropdown.close();
    }, 300);
  }
}
